// This function allow to reference chunks
__webpack_require__.miniCssF = (chunkId) => {
  // return url for filenames not based on template
  
  // return url for filenames based on template
  return "owa." + {24014: "styles",65719: "today",}[chunkId] + ".p." + {24014: "8fe4237d",65719: "fc28cd15",}[chunkId] + ".css"
}